import ClassNames from 'classnames'

import classes from './cryptoPaymentFormGroup.module.scss'

export const CryptoPaymentFormGroup = ({ children }) => {
  const componentClassName = ClassNames(classes.cryptoPaymentFormGroup, 'formGroup')

  return <div className={componentClassName}>{children}</div>
}
